const links = document.querySelectorAll("a");

// Custom Scripts
document.addEventListener("DOMContentLoaded", () => {

  // Side Buttons
  const topBtn = document.querySelector('.lp-side-buttons a[href^="' + sideBtn.top + '"]');
  const newsBtn = document.querySelector('.lp-side-buttons a[href^="' + sideBtn.news + '"]');
  topBtn.setAttribute("href", sideBtn.top);
  topBtn.setAttribute("target", "_self");
  newsBtn.setAttribute("href", sideBtn.news);
  newsBtn.setAttribute("target", "_self");

  // Add target to specific link tags
  const lpLinks = document.querySelectorAll('.ecom-collection__product-item a[href^="/"]');
  for (var i = lpLinks.length - 1; i >= 0; i--) { lpLinks[i].setAttribute("target", "_blank") };

  // Fix collections links
  links.forEach((link) => {
    // Check if the link contains "/collections/x" using regex
    if (/\/collections\/(.*)\/products\/(.*)/.test(link.href)) {
      // Replace "/collections/x" with "/products/y" using regex replace
      link.href = link.href.replace(
        /\/collections\/(.*)\/products\/(.*)/,
        "/products/$2"
      );
    }
  });

  // Add links to featured product's image
  const featProducts = document.querySelectorAll(
    ".lp-section-product-featured a.ecom-product__heading"
  );
  for (var i = featProducts.length - 1; i >= 0; i--) {
    var product = featProducts[i].closest(".lp-section-product-featured");
    var productImg = product.querySelector(".ecom-product-single__media--image img");

    var link = document.createElement("a");
    link.setAttribute("href", featProducts[i].getAttribute("href"));
    link.setAttribute("title", featProducts[i].getAttribute("title"));
    link.setAttribute("target", "_blank");
    product
      .querySelector(".ecom-product-single__media--image")
      .appendChild(link);
    link.appendChild(productImg);
  }

  // Add class to sold out items
  /*const soldOuts = document.querySelectorAll(".ecom-collection__product-badge--sold-out");
  for (var i = soldOuts.length - 1; i >= 0; i--) {
    var parent = soldOuts[i].closest(".ecom-collection__product-item");
    parent.classList.add("lp-product-sold_out");
  }*/

  // Move New Arrival badge element
  const newArrivals = document.querySelectorAll(".ecom-collection__product-badge.--custom")
  if (newArrivals.length > 0) {
    for (const badge of newArrivals) {
      var badge2Move = badge.querySelector(".ecom-collection__product-badge--custom")
      var parent = badge.parentNode
      var badgeContainet = parent.querySelector(".ecom-collection__product-item--inner .ecom-collection__product-badge")
      if (badgeContainet !== null) {
        badgeContainet.append(badge2Move)
        badge.remove()
      }
    }
  }

  // Custom Badges
  if (productBadges && productBadges.length > 0) {

    // badge loop
    for (const badge of productBadges) {
      var badgeEl = document.createElement("img")
      badgeEl.src = badge.img
      badgeEl.setAttribute("loading", "lazy")
      badgeEl.classList.add("lp-product-badge")

      // product loop
      for (const product of badge.products) {
        const badgeElClone = badgeEl.cloneNode(true)
        const productEl = document.querySelector(".ecom-collection__product-item[data-product-handle=" + product + "]")
        const featuredProductEl = document.querySelector(".ecom-product-form[data-handle=" + product + "]")
        if (productEl) {
          productEl.querySelector(".ecom-collection__product-item--inner").append(badgeElClone)
        } else if (featuredProductEl) {
          featuredProductEl.classList.add("lp-badge-item")
          featuredProductEl.querySelector(".ecom-product-single__media--featured").append(badgeElClone)
        }
      } // end product loop

    } // end badge loop

  }

})

// Hide more than one variant switcher
// const richVariants = document.querySelectorAll('.ecom-collection__product-form.ecom-product-form')

// const local = {
//   showMoreText: 'Skonfiguruj',
//   hideMoreText: 'Zwiń'
// }

// if (richVariants) {
//   for (var i = richVariants.length - 1; i >= 0; i--) {

//     if (
//       richVariants[i].querySelector('.ecom-collection__product-picker-other:nth-of-type(2)')
//       ||
//       richVariants[i].querySelector('.ecom-collection__product-picker-other ul li:nth-of-type(3)')
//       ) {

//       var btn = document.createElement('button')
//       btn.innerText = local.showMoreText
//       btn.type = 'button'
//       btn.classList.add('lp-product-variants-action-show_more')

//       richVariants[i].classList.add('lp-product-variants-wrapper')
//       richVariants[i].appendChild(btn)

//       btn.addEventListener('click', toggleVariantsWrapper)

//     }
//   }
// }

// function toggleVariantsWrapper() {
//   const btn = event.target
//   const parent = event.target.parentElement
//   parent.classList.toggle('lp-product-variants-wrapper')

//   if (btn.innerText == local.hideMoreText) {
//     btn.innerText = local.showMoreText
//   } else {
//     btn.innerText = local.hideMoreText
//   }

//   // const hideVariants = setTimeout(() => {
//   //   parent.classList.toggle('lp-product-variants-wrapper')
//   //   btn.innerText = local.showMoreText
//   // }, 10000)
// }

// Side Buttons (old code)
// const socialUrl = {
//     facebook: 'https://www.facebook.com/mihomepl',
//     instagram: 'https://www.instagram.com/mihome.pl'
//   }
// document
//   .querySelector('.lp-side-buttons a[href^="/facebook"]')
//   .setAttribute("href", socialUrl.facebook);
// document
//   .querySelector('.lp-side-buttons a[href^="/instagram"]')
//   .setAttribute("href", socialUrl.instagram);